import "./App.css";
import { Calculator } from "./components/cal";

function App() {
  return (
    <div className="App">
      <Calculator />
    </div>
  );
}

export default App;
